import {
  GET_OVERNIGHT_CAMP_REVIEW_SUBMIT_DETAILS,
  POST_OVERNIGHT_CAMP_REVIEW_SUBMIT_DETAILS,
  GET_OVERNIGHT_CAMP_REOPEN_REPORT_DETAILS
} from '@config/api-config';
import { asyncRequest } from '@config/http-config';
import * as types from './types';

// eslint-disable-next-line import/prefer-default-export
export const getOvernightCampDataReviewSubmit =
  (branchNumber, reportBatchId, year) => (dispatch, getState) =>
    asyncRequest({
      url: GET_OVERNIGHT_CAMP_REVIEW_SUBMIT_DETAILS(
        branchNumber,
        reportBatchId,
        year
      ),
      successAction: data => ({
        type: types.OVERNIGHT_CAMP_GET_REVIEW_SUBMIT_SUCCESS,
        async: true,
        payload: data,
        state: getState()
      }),
      failureAction: error => ({
        type: types.OVERNIGHT_CAMP_GET_REVIEW_SUBMIT_FAILURE,
        payload: error
      }),
      dispatch
    });

export const postOvernightCampDataReviewSubmit =
  payloadBody => (dispatch, getState) =>
    asyncRequest({
      url: POST_OVERNIGHT_CAMP_REVIEW_SUBMIT_DETAILS(),
      method: 'POST',
      data: payloadBody,
      successAction: data => ({
        type: types.OVERNIGHT_CAMP_POST_REVIEW_AND_SUBMIT_SUCCESS,
        async: true,
        payload: data,
        state: getState()
      }),
      failureAction: error => ({
        type: types.OVERNIGHT_CAMP_POST_REVIEW_AND_SUBMIT_FAILURE,
        payload: error
      }),
      dispatch
    });

export const getOvernightCampReopenReport =
  (branchNumber, reportBatchId, year) => (dispatch, getState) =>
    asyncRequest({
      url: GET_OVERNIGHT_CAMP_REOPEN_REPORT_DETAILS(
        branchNumber,
        reportBatchId,
        year
      ),
      successAction: data => ({
        type: types.OVERNIGHT_CAMP_GET_REOPEN_SUCCESS,
        async: true,
        payload: data,
        state: getState()
      }),
      failureAction: error => ({
        type: types.OVERNIGHT_CAMP_GET_REOPEN_FAILURE,
        payload: error
      }),
      dispatch
    });

export const resetReduxState = key => ({
  type: 'RESET_KEY',
  payload: { key }
});
